import { isAfter } from "date-fns";
import { TaskStatus } from "src/generated/graphqlTypes";
import {
  GanttSchedulePhaseFragment,
  GanttScheduleSubPhaseFragment,
  GanttScheduleTaskFragment,
} from "src/routes/projects/schedule-v2/gantt/ScheduleGantt.generated";
const globalMilestoneTaskClass = "global-milestone-task";
const potentialDelayedTaskClass = "potential-delay-task";
const confirmedDelayedTaskClass = "confirmed-delay-task";
const completedTaskClass = "completed-task";
const completedSubPhaseClass = "completed-sub-phase";
const completedPhaseClass = "completed-phase";
type TaskClasses =
  | typeof globalMilestoneTaskClass
  | typeof potentialDelayedTaskClass
  | typeof confirmedDelayedTaskClass
  | typeof completedTaskClass
  | typeof completedPhaseClass
  | typeof completedSubPhaseClass;

export function getStyleClassesForGanttTask(scheduleTask: GanttScheduleTaskFragment): TaskClasses | undefined {
  const {
    globalTask,
    baselineInterval2,
    interval: { endDate },
    status,
  } = scheduleTask;
  const baselineEndDate = baselineInterval2?.endDate;

  if (globalTask?.isMilestone) return globalMilestoneTaskClass;
  if (status === TaskStatus.Complete) return completedTaskClass;
  // Highlight tasks that are either expected to be delayed vs baseline, or are already delayed vs baseline by comparing the baseline to today's date
  if (baselineEndDate && isAfter(endDate, baselineEndDate)) {
    const baselineHasPast = isAfter(new Date(), baselineEndDate);
    return baselineHasPast ? confirmedDelayedTaskClass : potentialDelayedTaskClass;
  }

  return undefined;
}

export function getStyleClassesForGanttPhase(schedulePhase: GanttSchedulePhaseFragment): TaskClasses | undefined {
  const {
    progress: {
      scheduleSubPhaseProgress: { completed, total },
    },
  } = schedulePhase;
  if (completed === total) return completedPhaseClass;
  return undefined;
}

export function getStyleClassesForGanttSubPhase(
  scheduleSubPhase: GanttScheduleSubPhaseFragment,
): TaskClasses | undefined {
  const {
    progress: {
      taskProgress: { completed, total },
    },
  } = scheduleSubPhase;
  if (completed === total) return completedSubPhaseClass;
  return undefined;
}
